import { useCurrentUserData } from '~/root/Auth';
import { MedlyNavButton } from '~/root/Medly';
import { NavigationLink } from '../../NavigationLink';
import { NavigationSection } from '../../NavigationSection';
import { SubNavigation } from '../../SubNavigation';
import { CreditsBanner, TenHourTurnaroundBanner } from '../banners';
import { config } from '../config';

// This menu is also used for subscriptions with 0 capacity points
export const RegularNavigation = () => {
  const { marketingCampaigns } = useCurrentUserData();

  return (
    <>
      <NavigationSection>
        <NavigationLink {...config.links.myOrders} />
        <NavigationLink {...config.links.myTeam} />
        <SubNavigation {...config.subMenus.billing}>
          <NavigationLink {...config.links.billingOverview} />
          <NavigationLink {...config.links.billingPaymentHistory} />
          <NavigationLink {...config.links.billingCreditHistory} />
          <NavigationLink {...config.links.billingCreditPacks} />
        </SubNavigation>
        <NavigationLink {...config.links.billingSubscriptions} />
        <NavigationLink {...config.links.holidayCalendar} />
        <NavigationLink {...config.links.customFields} />
        <NavigationLink {...config.links.styleTemplates} />
        <SubNavigation {...config.subMenus.settings}>
          <NavigationLink {...config.links.userDetails} />
          <NavigationLink {...config.links.security} />
        </SubNavigation>
        <NavigationLink {...config.links.needHelp} />
      </NavigationSection>

      <MedlyNavButton />

      <div className="lg:mx-0 mx-2 lg:space-y-2 space-y-3">
        <CreditsBanner />
        {marketingCampaigns?.tenHoursTurnaround && <TenHourTurnaroundBanner />}
      </div>
    </>
  );
};
